import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const Pergola = createSvgIcon(
  <path d="M8.27 0h7.46L24 5.79v3.96h-2.25v12H24V24H0v-2.25h2.25v-12H0V5.79L8.27 0ZM19.5 21.75v-12h-15v12h15ZM21.75 7.5v-.54l-6.463-4.523L17.186 7.5h4.564Zm-14.936 0 1.899-5.063L2.25 6.96v.54h4.564Zm2.403 0h5.566l-1.969-5.25h-1.628L9.217 7.5Z" />,
  'Pergola'
);

export { Pergola };